export default __webpack_public_path__ + "static/media/dark-universes-banner-landscape.e50bd9e2.jpg";